import React, { Component } from 'react';
import Swal from 'sweetalert2';
import NavBar from './NavBar.js';
import Footer from './Footer.js';
import { properties } from './properties.js';
import i18n from './I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Link } from "react-router-dom";
import { loadWeb3, logout, apiPublicRequest, apiSecuredRequest, cambiarIdioma, isUserOrWallet, setBearer, cargarIdiomaPreferido} from './functions.js';
import './css/ToolMenu.css';





class ToolMenu extends Component {

    async componentDidMount() {
        // 1. Carga de Lista de empresas
        await cargarIdiomaPreferido(this.cambiarIdioma);
        const bearer = await this.checkIfWeb3UserOrLoginUser()
        this.cargarCamposMarca(bearer);
  
    }

    cambiarIdioma = (idioma) => {
        const { i18n } = this.props;
        i18n.changeLanguage(idioma); 
        this.forceUpdate(); 
        Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
      };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

    async checkIfWeb3UserOrLoginUser(){
       
        
        let empresaIdVar;
       
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        const email = Cookies.get("email");
        this.setState({ email: email });
        bearerVar = Cookies.get("id");
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
      
        
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
       
        this.setState({account: account});

       
        return bearerVar;
       
    }

    

    async cargarCamposMarca(bearer) {
      let params = (new URL(document.location)).searchParams;
      const certificadoName = params.get("certificadoName");
      this.setState({ certificadoName })
      const certificadoId = params.get("certificadoId");
      this.setState({ certificadoId })

      let distinctCertificatesData = JSON.stringify({
        "certificadoId": `${certificadoId}`,
        "tipoStandard": ""
      });
      const camposDistintos= await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/campo/getCamposDistintos`, distinctCertificatesData, bearer);
      const campos =  camposDistintos.data;
      
      const ochoCAMPOS = campos.filter((campo) => campo.tipoCertificado == "8CAMPOS")[0]?.tipoCertificado || null;
      const dieciseisCAMPOS = campos.filter((campo) => campo.tipoCertificado == "16CAMPOS")[0]?.tipoCertificado || null;
      
      if (ochoCAMPOS) {
        this.setState({ camposS8: ochoCAMPOS });
      }
      
      if (dieciseisCAMPOS) {
        this.setState({ camposS16: dieciseisCAMPOS });
      }
      
  }

    constructor(props) {
      super(props)
      this.state = {
        account: null, 
        isRootAddress: false,
        email: null, 
        bearer: null,
        camposS8: null, 
        camposS16: null,
        certificadoId: null,
        empresaMapping: null,
        certificadoName: null,
        userRol: null,
        direccion: null
      }
    }

    render() {

      if (this.state.certificadoId != null && this.state.empresaMapping != null) {
        return (
          <>
          <NavBar mail={this.state.email} bearer={this.state.bearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />

          <div className="buttonContainer">
            <button onClick={(event) => { window.location.href = `/listaEmpresas` }} className="homePage_emailBtn">{i18n.t('allBrands')}</button>
          </div>

          <table className="cewyCertificateTypeTable">
            <div className="cewyCertificateContainer">
              <p className="cewyTitleBrands">{this.state.certificadoName}</p>
              <p className="cewySubtitleBrands">{i18n.t('generateQuiestion')}</p>

              <div className="cewyNewCertificateButton">
                {this.state.camposS8 != null ?
                  <button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard8/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="cewyCertificateTypeBtn">{i18n.t('s8')}</button>
                  : null}
              </div>

              <div className="cewyNewCertificateButton">
                {this.state.camposS16 != null ?
                  <button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard16/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="cewyCertificateTypeBtn">{i18n.t('s16')}</button>
                  : null}
              </div>

              <div className="cewyNewCertificateButton">
                {this.state.camposS24 != null ?
                  <button onClick={(event) => { window.location.href = `/${this.state.empresaMapping}/standard24/userCertificateList?certificadoId=${this.state.certificadoId}&certificadoName=${this.state.certificadoName}` }} className="cewyCertificateTypeBtn">Premium</button>
                  : null}
              </div>

            </div>
          </table>

          <Footer />

          </>
        );
      }
  
    }

}
export default withTranslation()(ToolMenu);